"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _partial = _interopRequireDefault(require("./partial.js"));
var _before = _interopRequireDefault(require("./before.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
var _default = exports.default = (0, _partial.default)(_before.default, 2);